'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const AccessibilityIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 9.50005C12.8 9.50005 13.5 8.80005 13.5 8.00005C13.5 7.20005 12.8 6.60005 12 6.60005C11.2 6.60005 10.5 7.20005 10.5 8.00005C10.5 8.80005 11.2 9.50005 12 9.50005Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.8 9.80005L15.1 9.90005C13.1 10.2001 10.9 10.2001 8.90005 9.90005L8.20005 9.80005L8.00005 11.3001C9.10005 11.4001 10.1 11.6001 11.3 11.6001C11.3 13.3001 10.3 14.8 8.90005 16.1L9.90005 17.2001C10.8 16.4001 11.6 15.5001 12.1 14.5001C12.6 15.4001 13.4 16.4001 14.2 17.2001L15.3 16.2001C13.9 14.9001 12.9 13.4001 12.9 11.7001C14 11.6 15.1 11.5001 16.2 11.4001L15.8 9.80005Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 3.55005C7.33324 3.55005 3.55005 7.33324 3.55005 12C3.55005 16.6669 7.33324 20.4501 12 20.4501C16.6669 20.4501 20.4501 16.6669 20.4501 12C20.4501 7.33324 16.6669 3.55005 12 3.55005ZM2.05005 12C2.05005 6.50482 6.50482 2.05005 12 2.05005C17.4953 2.05005 21.9501 6.50482 21.9501 12C21.9501 17.4953 17.4953 21.9501 12 21.9501C6.50482 21.9501 2.05005 17.4953 2.05005 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpAccessibilityIcon = forwardRef(AccessibilityIcon);

export { VpAccessibilityIcon as default };
